@if (tag.tagType == "TENANT") {
  <span [attr.data-cy]="'tenant-tag-icon-' + tag.id"
        [class]='"or-icon or-tiny or-icon-tenant " + inverseClass'
        title='Tag is part of a Tenant'>
  </span>
} @else if (tag.tagType == "CHANNEL_LINK_GROUP") {
  <span [attr.data-cy]="'channel-link-tag-icon-' + tag.id"
        [class]='"or-icon or-tiny or-icon-channel-link " + inverseClass'
        title='Tag is a channel link'>
  </span>
} @else if (tag.tagType == "LIGHTING_PROFILE") {
  <span [attr.data-cy]="'lighting-profile-tag-icon-' + tag.id"
        [class]='"or-icon or-tiny or-icon-lighting-profile " + inverseClass'
        title='Tag is a lighting profile'>
  </span>
} @else if (tag.tagType == "ROOM") {
  <span [attr.data-cy]="'room-tag-icon-' + tag.id"
        [class]='"or-icon or-tiny or-icon-room " + inverseClass'
        title='Tag is a room'>
  </span>
}